/* cmp-compare-table.js — binding robuste + lightbox images/vidéos */
(function(){
  // Flag debug : permet de vérifier dans le DOM que le JS est bien chargé
  document.documentElement.setAttribute('data-cmp-compare-js','on');

  // ---------- LIGHTBOX ----------
  let LB = null;
  const lockScroll = () => { document.documentElement.style.overflow = 'hidden'; };
  const unlockScroll = () => { document.documentElement.style.overflow = ''; };

  const ensureLightbox = () => {
    if (LB && document.body.contains(LB)) return LB;
    LB = document.getElementById('clv3-lightbox');
    if (LB) return LB;

    LB = document.createElement('div');
    LB.className = 'clv3__lightbox';
    LB.id = 'clv3-lightbox';
    LB.innerHTML = `
  <div class="clv3lb__dialog" role="dialog" aria-modal="true" aria-labelledby="clv3lb-title">
    <div class="clv3lb__head">
      <div id="clv3lb-title" class="clv3lb__title">Comparatif en photo</div>
      <button class="clv3lb__close" aria-label="Fermer">✕</button>
    </div>

    <div class="clv3lb__grid">
      <div class="clv3lb__card is-main">
        <div class="clv3lb__label">
          LALAHOME — bac intégré <span class="clv3lb__badge">Recommandé</span>
        </div>
        <div class="clv3lb__fig">
          <img class="main-img" alt="Visuel LALAHOME">
        </div>
        <div class="clv3lb__bullets">
          <div class="clv3lb__li"><i></i><span>Pas d’accessoire à rajouter : bac intégré à la sortie.</span></div>
          <div class="clv3lb__li"><i></i><span>Entrée propre, moins d’éparpillement autour de la litière.</span></div>
        </div>
      </div>

      <div class="clv3lb__card">
        <div class="clv3lb__label">Concurrents — bac/tapis additionnel</div>
        <div class="clv3lb__fig clv3lb__right">
          <!-- contenu (images/vidéos) injecté dynamiquement -->
        </div>
        <div class="clv3lb__bullets">
          <div class="clv3lb__li clv3lb__li--no"><i></i><span>Besoin d’un bac/tapis posé devant la litière.</span></div>
          <div class="clv3lb__li clv3lb__li--no"><i></i><span>Plus d’encombrement et de nettoyage.</span></div>
        </div>
      </div>
    </div>
  </div>`;
    document.body.appendChild(LB);

    const close = () => { LB.classList.remove('is-open'); unlockScroll(); };
    LB.addEventListener('click', e => { if (e.target === LB) close(); });
    LB.querySelector('.clv3lb__close').addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (LB.classList.contains('is-open') && e.key === 'Escape') close();
    });

    return LB;
  };

  // Ouvrir la lightbox à partir d’une ligne du tableau
  const openFromRow = (tr) => {
    if (!tr) return;
    const lb = ensureLightbox();

    // ----- 1) IMAGES / VIDÉOS -----
    const mainUrl    = (tr.dataset.main || '').trim();   // image LALAHOME (gauche)
    const altImages  = (tr.dataset.alt || '').split(',').map(s=>s.trim()).filter(Boolean);
    const altVideos  = (tr.dataset.altVideo || '').split(',').map(s=>s.trim()).filter(Boolean);

    // gauche (LALAHOME) : image
    const mainImg = lb.querySelector('.main-img');
    if (mainImg) mainImg.src = mainUrl || '';

    // droite (concurrents) : vidéo prioritaire si fournie, sinon images
    const rightFig = lb.querySelector('.clv3lb__fig.clv3lb__right');
    if (rightFig) {
      rightFig.innerHTML = '';

      const addVideo = (url, cls='alt-main') => {
        const v = document.createElement('video');
        v.src = url;
        v.className = cls;
        v.setAttribute('playsinline','');
        v.setAttribute('muted','');
        v.setAttribute('loop','');
        v.autoplay = true;
        v.controls = false; // mettre false si tu ne veux pas les contrôles visibles
        rightFig.appendChild(v);
      };
      const addImg = (url, cls='alt-main', alt='Concurrent — photo') => {
        const i = document.createElement('img');
        i.className = cls; i.alt = alt; i.src = url;
        rightFig.appendChild(i);
      };

      if (altVideos.length) {
        addVideo(altVideos[0], 'alt-main');
        if (altImages[0]) addImg(altImages[0], 'alt-float', 'Concurrent — photo 2');
      } else if (altImages.length) {
        addImg(altImages[0], 'alt-main', 'Concurrent — photo 1');
        if (altImages[1]) addImg(altImages[1], 'alt-float', 'Concurrent — photo 2');
      }
    }

    // ----- 2) TITRES (facultatifs via data-*) -----
    const tMain = tr.dataset.titleMain || 'LALAHOME — comparaison';
    const tAlt  = tr.dataset.titleAlt  || 'Concurrents';
    const labels = lb.querySelectorAll('.clv3lb__label');
    if (labels[0]) {
      // On remplace seulement le texte de gauche, on conserve le badge
      const firstNode = labels[0].childNodes[0];
      const textNode = document.createTextNode(tMain + ' ');
      if (firstNode && firstNode.nodeType === 3) {
        labels[0].replaceChild(textNode, firstNode);
      } else {
        labels[0].insertBefore(textNode, labels[0].firstChild);
      }
    }
    if (labels[1]) labels[1].textContent = tAlt;

    // ----- 3) BULLETS (facultatifs via data-*) -----
    const setBullets = (containerSel, data, isPositive=true) => {
      const wrap = lb.querySelector(containerSel);
      if (!wrap || !data) return;
      const items = data.split('|').map(s=>s.trim()).filter(Boolean);
      if (!items.length) return;
      wrap.innerHTML = items.map(txt =>
        `<div class="clv3lb__li ${isPositive ? '' : 'clv3lb__li--no'}"><i></i><span>${txt}</span></div>`
      ).join('');
    };
    setBullets('.clv3__lightbox .is-main .clv3lb__bullets', tr.dataset.bulletsMain || '', true);
    setBullets('.clv3__lightbox .clv3lb__card:not(.is-main) .clv3lb__bullets', tr.dataset.bulletsAlt || '', false);

    // ----- 4) OUVERTURE -----
    lb.classList.add('is-open');
    lockScroll();
    requestAnimationFrame(()=> lb.querySelector('.clv3lb__close')?.focus());
  };

  // ---------- BINDING PAR DÉLÉGATION (fonctionne même si injecté tard) ----------
  document.addEventListener('click', (e) => {
    // bouton dédié éventuel
    const btn = e.target.closest('.clv3__row-gallery .clv3__photobtn');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      const tr = btn.closest('tr.clv3__row-gallery');
      if (tr) openFromRow(tr);
      return;
    }
    // ligne entière cliquable (hors liens/boutons/tabs)
    const row = e.target.closest('tr.clv3__row-gallery');
    if (row && !e.target.closest('a,button,[role="tab"]')) {
      e.preventDefault();
      openFromRow(row);
    }
  });

  // ---------- DÉCORATION DES LIGNES GALERIE (icône, a11y) ----------
  const decorateRows = (root=document) => {
    root.querySelectorAll('tr.clv3__row-gallery').forEach(tr=>{
      tr.setAttribute('tabindex','0');
      tr.setAttribute('role','button');
      // Neutralise toute éventuelle icône "fantôme" via ::after externe
      tr.style.setProperty('--photoicon-after', 'none');
      // Injecte la petite icône dans la 1re cellule si absente
      if (!tr.querySelector('.clv3__photoicon')) {
        const feat = tr.querySelector('.feat');
        if (feat) {
          const ico = document.createElement('span');
          ico.className = 'clv3__photoicon';
          ico.setAttribute('aria-hidden','true');
          feat.appendChild(ico);
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=>decorateRows());
  } else {
    decorateRows();
  }

  // Observe les ajouts dynamiques (Shopify sections, etc.)
  const mo = new MutationObserver((muts)=>{
    muts.forEach(m=>{
      m.addedNodes && m.addedNodes.forEach(n=>{
        if (n.nodeType===1) {
          if (n.matches && n.matches('tr.clv3__row-gallery')) decorateRows(n.parentNode||n);
          else if (n.querySelector) decorateRows(n);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  // ---------- SWITCH CONCURRENTS (mobile) : étiquette de la colonne affichée ----------
  const relabel = () => {
    document.querySelectorAll('#cmp-lala-v3 .clv3__switch [data-col].is-active').forEach(btn=>{
      const col = Number(btn.dataset.col);
      const name = (btn.textContent||'').trim();
      document.querySelectorAll('#cmp-lala-v3 .clv3__table tbody tr').forEach(tr=>{
        tr.querySelectorAll('td').forEach(td=> td.removeAttribute('data-alt'));
        const altTd = tr.querySelector(`td:nth-child(${col})`);
        if (altTd) altTd.setAttribute('data-alt', name);
      });
      const sec = document.querySelector('#cmp-lala-v3'); if (sec) sec.dataset.show = String(col);
    });
  };

  document.addEventListener('click', (e)=>{
    const b = e.target.closest('#cmp-lala-v3 .clv3__switch [data-col]');
    if (b) {
      b.closest('.clv3__switch')?.querySelectorAll('[data-col]').forEach(x=>{
        const on = x===b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-selected', on?'true':'false');
      });
      relabel();
    }
  });

})();